<template>
    <div class="body">
        <div class="search-box">
<!--            <div>-->
<!--                <span class="title">年级：</span>-->
<!--                <el-date-picker v-model="searchGrade" type="year" value-format="yyyy" placeholder="请选择选择年级" @change="search">-->
<!--                </el-date-picker>-->
<!--            </div>-->
            <div style="margin-left: 16px;margin-right: 16px;">
                <span class="title">专业：</span>
                <el-select @change="filterData" class="search-input" filterable clearable v-model="searchMajor" placeholder="请选择专业">
                    <el-option v-for="item in major" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div>
                <span class="title">学期：</span>
                <el-select @change="filterData" class="search-input" clearable v-model="searchSemester" placeholder="请选择学期">
                    <el-option v-for="item in semester" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class='margin-left-30'>
                <el-button class="primary-btn" @click="reset()">重置</el-button>
                <el-button type="primary" style="margin-left: 16px" @click="filterData()">查询</el-button>
            </div>
        </div>
        <div class="container">
            <div class="table-cls">
                <el-table
                    :data="tableData"
                    class="table"
                    border
                    style="font-size: 14px"
                    :cell-style="{ color: '#666666' }"
                    :header-cell-style="{ background: '#eef1f6', color: '#333333', height: '49px', fontWeight: 500 }"
                >
                    <el-table-column prop="grade" align="center" label="年级"></el-table-column>
                    <el-table-column prop="major_id" align="center" label="专业">
                        <template slot-scope="scope">
                            {{ tableMajorHash[scope.row.major_id] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="semester" align="center" label="学期">
                        <template slot-scope="scope">
                            {{ semesterHash[scope.row.semester] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="org" align="center" v-if="this.accountOrg == 1" label="所属院校">
                        <template slot-scope="scope">
                            {{ orgHash[scope.row.org] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="org" align="center" v-if="this.accountOrg == 1" label="发布状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.is_pub === 1 ? 'color-blue' : 'color-red'">
                                {{ scope.row.is_pub === 1 ? '已发布' : '未发布' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220px" align="center" fixed="right">
                        <template slot-scope="scope">
                            <div class="table-btn">
<!--                                <el-button class="primary-btn" @click="toResultMsg(scope.row)">学生成绩</el-button>-->
                                <el-button class="primary-btn" @click="toCourseResult(scope.row)">查看成绩</el-button>
                                <el-button
                                    class="primary-btn"
                                    @click="release(scope.$index, scope.row.semester, scope.row.id, scope.row.org)"
                                    :disabled="scope.row.org != accountOrg"
                                    v-if="scope.row.is_pub === 0 || scope.row.is_pub === null"
                                    >成绩发布</el-button
                                >
                                <el-button
                                    type="danger"
                                    @click="cancelRelease(scope.$index, scope.row.semester, scope.row.id, scope.row.org)"
                                    v-if="scope.row.is_pub === 1"
                                    >取消发布</el-button
                                >
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="pageIndex"
                    :page-size="10"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'exam',
    data() {
        return {
            tableMajorHash:[],
            accountOrg: 0,
            orgHash: [],
            crsDataHash: [],
            searchGrade: '',
            searchMajor: '',
            searchSemester: '',
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            tableData: [],
            major: [],
            majorHash: [],
            semester: [],
            semesterHash: []
        };
    },

    created() {
        this.accountOrg = localStorage.getItem('org');
        this.getData();
        this.getTblInfo();
        this.getTransitionValue();
        this.getCrsData();
    },
    methods: {
        filterData(){
            this.pageIndex = 1
            this.search()
        },
        toResultMsg(data) {
            this.$router.push({
                path: '/resultMsg',
                query: {
                    semesterName: this.semesterHash[data.semester],
                    majorName: this.majorHash[data.major_id],
                    semester_id: data.id,
                    major_id: data.major_id,
                    grade: data.grade,
                    semester: data.semester,
                    org: data.org
                }
            });
        },
        toCourseResult(data) {
            if (data.crs_data.length == 0) {
                this.$message.error('该专业学期暂未排课,请先排课！');
                return false;
            }
            let crs_data = JSON.stringify(data.crs_data);

            this.$router.push({
                path: '/courseResult',
                query: {
                    crsData: crs_data,
                    crsId: data.crs_data[0],
                    semesterName: this.semesterHash[data.semester],
                    majorName: this.majorHash[data.major_id],
                    semester_id: data.id,
                    major_id: data.major_id,
                    grade: data.grade,
                    semester: data.semester,
                    org: data.org
                }
            });
        },
        release(index, semester, id, org) {
            console.log(index);
            let parameter = { semester_id: id, is_pub: 0 };

            this.$put(this.BASEURL + `/achievement/release`, parameter).then((res) => {
                if (res.code === 200) {
                    this.$message.success('发布成功！');
                    this.tableData[index].is_pub = 1;
                } else {
                    console.log(res.error);
                }
            });
        },
        cancelRelease(index, semester, id, org) {
            let parameter = { semester_id: id, is_pub: 1 };

            this.$put(this.BASEURL + `/achievement/release`, parameter).then((res) => {
                if (res.code === 200) {
                    this.$message.success('取消发布成功！');
                    this.tableData[index].is_pub = 0;
                } else {
                    console.log(res.error);
                }
            });
        },
        //获取课程列表
        getCrsData() {
            this.$get(this.BASEURL + '/tution/course/GET').then((res) => {
                if (res.code === 200) {
                    let hash = [];
                    res.crsData.forEach((item, index) => {
                        hash[item.id] = item.name;
                    });
                    this.crsDataHash = hash;
                } else {
                    console.log(res.error);
                }
            });
        },
        //获取列表数据
        getData() {
            this.$get(
                this.BASEURL +
                    `/achievement/management?option=1&page=${this.pageIndex}&major=${this.searchMajor}&semester=${this.searchSemester}&grade=${this.searchGrade}`
            ).then((res) => {
                if (res.code === 200) {
                    this.tableData = res.data;
                    this.pageTotal = res.total;
                } else {
                    console.log(res.error);
                }
            });
        },
        search() {
            this.$get(
                this.BASEURL +
                    `/achievement/management?option=2&page=${this.pageIndex}&major=${this.searchMajor}&semester=${this.searchSemester}&grade=${this.searchGrade}`
            ).then((res) => {
                if (res.code === 200) {
                    this.tableData = res.data;
                    this.pageTotal = res.total;
                } else {
                    console.log(res.error);
                }
            });
        },
        getTblInfo() {
            this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [
                    ['id', 'grade,level,name', 'major_base_t'],
                    ['org', 'org_name', 'academy_base_t'],
                    ['id', 'name', 'major_base_t'],
                ],
                state: 1
            }).then((res) => {
                if (res.code === 200) {
                    this.major = res.data[0][0];
                    this.majorHash = res.data[0][1];
                    this.orgHash = res.data[1][1];
                    this.tableMajorHash = res.data[2][1];
                } else {
                    console.log(res.error);
                }
            });
        },
        getTransitionValue() {
            let data = ['major_semester'];
            this.$post(this.BASEURL + '/assets/transition/GET', {
                key_list: data
            }).then((res) => {
                if (res.code === 200) {
                    this.semester = res.data.major_semester[0];
                    this.semesterHash = res.data.major_semester[1];
                } else {
                    console.log(res.error);
                }
            });
        },
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        reset() {
            this.searchGrade = '';
            this.searchMajor = '';
            this.searchSemester = '';
            this.getData();
        }
    }
};
</script>

<style lang="scss" scoped>
.body {
    button {
        padding: 8px 15px;
        font-size: 14px;
    }
}

.search-box {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding: 28px 30px;
    margin-top: $distance;
    margin-bottom: $distance;
    border-radius: $radius;
    .search-input {
        width: 240px;
    }
    .title {
        font-size: $title-size;
        line-height: 15px;
        color: $title-color;
    }
}

.primary-btn {
    border-color: #409eff;
    color: #409eff;
}
.btn-box {
    margin-top: 40px;
    zoom: 1;
    .btn {
        float: right;
        overflow: hidden;
    }
}
.btn-box:after {
    content: '020';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}
.table-btn {
    display: flex;
    button {
        font-size: 14px;
        margin-right: $btn-right;
        margin-left: 0;
    }
}
</style>
